export const enum ValidationStatusId {
  Default = 'default',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
}

export type DateValidator = (date: Date) => string

export function futureDateValidator(today: Date): DateValidator {
  const normalizedToday = today.setHours(0, 0, 0, 0)

  return (date: Date) => {
    const normalizedInputDate = date.setHours(0, 0, 0, 0)
    return normalizedInputDate > normalizedToday
      ? 'Date must be in the past.'
      : ''
  }
}

export function emailValidator(email: string) {
  const reg =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return reg.test(email)
}

export function stringIsInteger(input: string) {
  return /^\d+$/.test(input)
}
